"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _helpers = require("composer-lib/lib/helpers");

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _composer = require("composer-lib/redux/actions/composer");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _lock = require("composer-lib/redux/actions/lock");

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save
  };
};

var mapDispatchToProps = {
  saveComposition: _composer.saveComposition,
  saveCompositionPending: _composer.saveCompositionPending,
  showLockedModal: _lock.showLockedModal
};
var SaveButtonContainer = (0, _createReactClass.default)({
  displayName: "SaveButtonContainer",
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    onClick: _propTypes.default.func,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.updateHelpers = (0, _helpers.makeComposerHelperUpdater)(this, [_helpers.ComposerHelperNames.SAVE_CHANGED_COMPOSITION]);
    this.updateHelpers();
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateHelpers(nextProps);
  },
  hardSavePost: function hardSavePost() {
    (0, _UsageTracking.trackEvent)({
      action: 'format-bar-click',
      extra: {
        'click-type': 'save'
      },
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
    });
    this.saveChangedComposition();
  },
  handleClick: function handleClick(e) {
    this.hardSavePost();
    var onClick = this.props.onClick;

    if (onClick && typeof onClick === 'function') {
      onClick(e);
    }
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        composition = _this$props.composition,
        lock = _this$props.lock,
        saveState = _this$props.saveState;

    if (composition.isReadOnly()) {
      return null;
    }

    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    return _react.default.createElement(_UIButton.default, {
      "data-test": "save-button",
      disabled: locked,
      onClick: this.handleClick,
      size: "small",
      use: "tertiary-light"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.header.save"
    }));
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SaveButtonContainer);

exports.default = _default;
module.exports = exports.default;